var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_mixins["summary-box"] = pug_interp = function(selectedCompany, save, disabled, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"summary-box isTransparent\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns\"\u003E";
if (selectedCompany) {
pug_html = pug_html + "\u003Cspan class=\"summary-box__title\"\u003E\u003Cstrong\u003EFirma:\u003C\u002Fstrong\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = ' '+ selectedCompany) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"hide-for-small-only\"\u003E&nbsp;\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns text-right pull-right\"\u003E";
block && block();
if (save) {
pug_html = pug_html + "\u003Cbutton" + (" class=\"button button-primary isOutline\""+pug.attr("ng-click", save, true, true)+pug.attr("ng-disabled", disabled, true, true)+pug.attr("data-cy", cyData, true, true)) + "\u003ESpeichern\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};



















pug_html = pug_html + "\u003Cdiv class=\"cockpit_allgemein-wrapper\" overlay=\"AllgemeinCtrl.isLoading()\"\u003E";
pug_mixins["summary-box"]('{{ AllgemeinCtrl.customer.name }}', 'AllgemeinCtrl.save()', 'AllgemeinCtrl.validateForms()');
pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EModule aktivieren\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cul class=\"module-select\"\u003E\u003Cli class=\"module-select__item\" ng-repeat=\"(key, module) in AllgemeinCtrl.SelectedCustomerMenuConstants\" ng-click=\"AllgemeinCtrl.moduleClick( key )\" ng-class=\"{isSelected: AllgemeinCtrl.isModuleSelected(key)}\"\u003E\u003Ci class=\"module-select__icon icon font-icon icon-{{ key | menuIcon: AllgemeinCtrl.SelectedCustomerMenuConstants }}\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"module-select__title\"\u003E\u003Ch5\u003E{{ key | menuTitle: AllgemeinCtrl.SelectedCustomerMenuConstants }}\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EKundenvertragsebene\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"columns small-12 medium-4\"\u003E\u003Cdiv class=\"small-11\"\u003E";
pug_mixins["select"].call({
attributes: {"key": "AllgemeinCtrl.configuration.contract_details.contract_level","title": "Vertragslevel","attributes": {"ng-options":"option.name as option.display for option in AllgemeinCtrl.defaultContractLevels"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12 medium-4\"\u003E\u003Cdiv class=\"small-11\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.contract_details.user_fee","title": "Zugangsgebühr (€)","required": pug.escape(true),"validationMessages": {"required":"Pflichtfeld","vnMin":"Der minimale Wert beträgt {{ 0 | currency }}"},"attributes": {"vn-min":"0","vn-currency":"true"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12 medium-4\"\u003E\u003Cdiv class=\"small-11\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.contract_details.percentage","title": "Standard Prozentsatz (%)","required": pug.escape(true),"validationMessages": {"required":"Pflichtfeld","vnMin":"Der minimale Wert beträgt 0 %"},"attributes": {"vn-min":"0","vn-percent":"true"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.contractLevels"}
});
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.contract_details.userlane_tags","title": "Individuelle Userlane Tags"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor || AllgemeinCtrl.iAmGAdvisor || AllgemeinCtrl.iAmAdvisor\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EBranding festlegen\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["select"].call({
block: function(){
pug_html = pug_html + "\u003Coption value=\"\"\u003EKein Branding\u003C\u002Foption\u003E";
},
attributes: {"key": "AllgemeinCtrl.branding","attributes": {"ng-options":"branding for branding in AllgemeinCtrl.brandingList","ng-change":"AllgemeinCtrl.unsavedBranding = true"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6 no-label\"\u003E&nbsp;&nbsp;&nbsp;&nbsp;\u003Cspan ng-if=\"AllgemeinCtrl.unsavedBranding\"\u003E(ungespeichert)\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor || AllgemeinCtrl.iAmAdvisor || AllgemeinCtrl.iAmGAdvisor\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EAllgemeine Kundeninformationen (nur intern)\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E";
globals = {};
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EAllgemeine Kundeninformationen \u002F Änderungslog\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"information_enable\" tabindex=\"1\"\u003E\u003C\u002Flabel\u003E\u003Cspan class=\"component-name\"\u003EAllgemeine Kundeninformationen \u002F Änderungslog anzeigen\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "information_enable","key": "AllgemeinCtrl.configuration.dashboard_config.information_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel for=\"information_content\"\u003EEintrag mit Datum und Kürzel dann Info\u003C\u002Flabel\u003E\u003Cdiv class=\"quill-editor\"\u003E\u003Cng-quill-editor class=\"quill-content\" id=\"allgemein-content\" name=\"inputInformationContent\" ng-model=\"AllgemeinCtrl.configuration.dashboard_config.information_config.text\" theme=\"snow\" placeholder=\"Informationen hier angeben...\"\u003E\u003C\u002Fng-quill-editor\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"AllgemeinCtrl.forms.welcome_block_form.inputInformationContent.$error\"\u003E\u003Cdiv class=\"helpText\" ng-message=\"required\"\u003EEs wird eine Eingabe benötigt\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.information_form"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor || AllgemeinCtrl.iAmAdvisor || AllgemeinCtrl.iAmGAdvisor || AllgemeinCtrl.iAmEmployer\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EDashboard Individualisierung\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E";
globals = {};
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EWillkommensnachricht\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"welcome_block_enable\" tabindex=\"1\"\u003E\u003C\u002Flabel\u003E\u003Cspan class=\"component-name\"\u003Eindividuelle Willkommensnachricht anzeigen\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "welcome_block_enable","key": "AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel for=\"welcome_block_content\"\u003EInhalt\u003C\u002Flabel\u003E\u003Cdiv class=\"row\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switch-is_html","title": "HTML","key": "AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.is_html"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"quill-editor\" ng-if=\"!AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.is_html\"\u003E\u003Cng-quill-editor class=\"quill-content\" id=\"allgemein-content\" name=\"inputWelcomeBlockContent\" ng-model=\"AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.text\" ng-required=\"AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.is_enabled\" theme=\"snow\" placeholder=\"Geben Sie hier eine individuelle Willkommensnachricht an - aktivieren nicht vergessen.\"\u003E\u003C\u002Fng-quill-editor\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-12\" ng-if=\"AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.is_html\"\u003E\u003Cdiv\u003E\u003Ctextarea ng-model=\"AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.text\" rows=\"10\" required=\"true\" ng-required=\"true\"\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv ng-bind-html=\"AllgemeinCtrl.configuration.dashboard_config.welcome_block_config.text | trustHtml\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"AllgemeinCtrl.forms.welcome_block_form.inputWelcomeBlockContent.$error\"\u003E\u003Cdiv class=\"helpText\" ng-message=\"required\"\u003EEs wird eine Eingabe benötigt\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.welcome_block_form"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003Chr\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EÜberschrift\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchCustomHeadline\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003Eindividuelle Überschriften aktivieren\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchCustomHeadline","key": "AllgemeinCtrl.configuration.dashboard_config.dashboard_headline_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.dashboard_config.dashboard_headline_config.dashboard_headline","title": "Überschrift","validationMessages": {"required":"Bitte hier Überschrift eintragen"},"attributes": {"ng-required":"AllgemeinCtrl.configuration.dashboard_config.dashboard_headline_config.is_enabled","ng-disabled":"!AllgemeinCtrl.configuration.dashboard_config.dashboard_headline_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.dashboard_config.dashboard_headline_config.dashboard_subheadline","title": "zweite Überschrift","validationMessages": {"required":"Bitte hier zweite Überschrif eintragen"},"attributes": {"ng-required":"AllgemeinCtrl.configuration.dashboard_config.dashboard_headline_config.is_enabled","ng-disabled":"!AllgemeinCtrl.configuration.dashboard_config.dashboard_headline_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.dashboardHeadlineForm"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003Chr\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EPortalvideo deaktivieren\u003C\u002Fh3\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchDashboardVideo\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003EPortalvideo auf Dashboard und Popup deaktivieren\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchDashboardVideo","key": "AllgemeinCtrl.configuration.dashboard_config.dashboard_video_config.is_enabled","labelHtmlClass": "switchbox-float-label","ng-true-value": "false","ng-false-value": "true"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"AllgemeinCtrl.iAmCmsEditor &amp;&amp; AllgemeinCtrl.configuration.modules.cms.enabled\"\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003ESchwarzes Brett\u003C\u002Fh3\u003E\u003Ca ui-sref=\"inApp.cms.editorlist({ custId: AllgemeinCtrl.customerId })\"\u003EZum Schwarzen Brett\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor || AllgemeinCtrl.iAmAdvisor || AllgemeinCtrl.iAmGAdvisor || AllgemeinCtrl.iAmEmployer\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EIndividuelle Bezeichnung in Navigationsleiste\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003Ch3\u003ECMS-Inhalte\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchCustomCMSConfig\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003Eindividuelle CMS Überschrift aktivieren\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchCustomCMSConfig","key": "AllgemeinCtrl.configuration.cms_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.cms_config.menu_title","title": "Alternativer Titel","validationMessages": {"required":"Bitte hier Überschrift eintragen"},"attributes": {"ng-required":"AllgemeinCtrl.configuration.cms_config.is_enabled","ng-disabled":"!AllgemeinCtrl.configuration.cms_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.cmsTitleForm"}
});
pug_html = pug_html + "\u003Cbr\u003E";
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003Ch3\u003ESteuerfreie Extras\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchCustomSEConfig\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003Eindividuelle Steuerfreie Extras Überschrift aktivieren\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchCustomSEConfig","key": "AllgemeinCtrl.configuration.steuerfrei_menu_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.steuerfrei_menu_config.menu_title","title": "Alternativer Titel","validationMessages": {"required":"Bitte hier Überschrift eintragen"},"attributes": {"ng-required":"AllgemeinCtrl.configuration.steuerfrei_menu_config.is_enabled","ng-disabled":"!AllgemeinCtrl.configuration.steuerfrei_menu_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.steuerfreiExtrasTitleForm"}
});
pug_html = pug_html + "\u003Cbr\u003E";
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 text-left\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EBonus Dashboard\u003C\u002Fh3\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchCustomBonusDashboardConfig\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003Eindividuelle Bonus Dashboard Überschrift aktivieren\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchCustomBonusDashboardConfig","key": "AllgemeinCtrl.configuration.bonus_dashboard_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.bonus_dashboard_config.menu_title","title": "Alternativer Titel","validationMessages": {"required":"Bitte hier Überschrift eintragen"},"attributes": {"ng-required":"AllgemeinCtrl.configuration.bonus_dashboard_config.is_enabled","ng-disabled":"!AllgemeinCtrl.configuration.bonus_dashboard_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.bonusDashboardTitleForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor || AllgemeinCtrl.iAmAdvisor || AllgemeinCtrl.iAmEmployer\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EAllgemein\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchForInformailingGDPR\" tabindex=\"0\"\u003E\u003Cspan class=\"component-name\"\u003EInfomailing Mitarbeiter\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchForInformailingGDPR","key": "AllgemeinCtrl.configuration.mailing.gdpr","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchForMailingDPA\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003EAuftragsverarbeitung Infomailing aktiv\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchForMainlingDPA","key": "AllgemeinCtrl.configuration.mailing.dpa","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.infomailing_form"}
});
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchForGDPR\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003EDatenschutzerklärung ergänzen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchForGDPR","key": "AllgemeinCtrl.configuration.GDPR_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel for=\"text\"\u003EInhalt\u003C\u002Flabel\u003E\u003Cdiv class=\"quill-editor\"\u003E\u003Cng-quill-editor class=\"quill-content\" id=\"GDPR-content\" name=\"inputGDPRText\" ng-model=\"AllgemeinCtrl.configuration.GDPR_config.text\" ng-required=\"AllgemeinCtrl.configuration.GDPR_config.is_enabled\" theme=\"snow\" placeholder=\"Text hier eingeben…\"\u003E\u003C\u002Fng-quill-editor\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"AllgemeinCtrl.forms.GDPR_form.inputGDPRText.$error\"\u003E\u003Cdiv class=\"helpText\" ng-message=\"required\"\u003EEs wird eine Eingabe benötigt\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.GDPR_form"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchDocumentsPartner\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003EDokumentenfluss über Partner\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchDocumentsPartner","key": "AllgemeinCtrl.configuration.direct_contract_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E";
globals = {}
pug_mixins["form"].call({
attributes: {"name": "AllgemeinCtrl.forms.salary_statement_form"}
});
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchForSalaryStatementConfig\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003EUpload Gehaltsabrechnung Meine Akte aktivieren\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"readonly": "!AllgemeinCtrl.iAmSpecialAdvisor","id": "switchForSalaryStatementConfig","key": "AllgemeinCtrl.configuration.salary_statement_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"switchForDomainConfig\" tabindex=\"1\"\u003E\u003Cspan class=\"component-name\"\u003EDomainbeschränkung\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchForDomainConfig","key": "AllgemeinCtrl.configuration.domains_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.domains_config.whitelisted_domains_list","title": "Whitelist","validationMessages": {"required":"Bitte hier Whitelist eintragen"},"attributes": {"ng-disabled":"!AllgemeinCtrl.configuration.domains_config.is_enabled","ng-required":"AllgemeinCtrl.configuration.domains_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-3\"\u003E";
pug_mixins["select"].call({
attributes: {"id": "selectDomainCheckType","key": "AllgemeinCtrl.configuration.domains_config.validation_strategy","title": "Validation Type","validationMessages": {"required":"Pflichtfeld"},"attributes": {"ng-options":"strategy.id as strategy.display for strategy in AllgemeinCtrl.VSP_CONSTANTS.DOMAINS_VALIDATION_STRATEGY","ng-disabled":"!AllgemeinCtrl.configuration.domains_config.is_enabled","ng-required":"AllgemeinCtrl.configuration.domains_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.domains_config.error_message","title": "Employee Error message","validationMessages": {"required":"Pflichtfeld"},"attributes": {"ng-disabled":"!AllgemeinCtrl.configuration.domains_config.is_enabled","ng-required":"AllgemeinCtrl.configuration.domains_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.domain_whitelist_form"}
});
pug_html = pug_html + "\u003Cbr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E\u003Clabel for=\"customerDomainsConfig\"\u003E\u003Cspan class=\"component-name\"\u003EDomain von Arbeitgeber E-Mail Adressen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "customerDomainsConfig","key": "AllgemeinCtrl.configuration.customer_domains_config.is_enabled","labelHtmlClass": "switchbox-float-label"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.customer_domains_config.emails_list","title": "Domainlist","validationMessages": {"required":"Bitte Arbeitnehmer Domains hier eintragen"},"attributes": {"ng-disabled":"!AllgemeinCtrl.configuration.customer_domains_config.is_enabled","ng-required":"AllgemeinCtrl.configuration.customer_domains_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv ng-if=\"!!AllgemeinCtrl.configuration.domains_config.is_enabled\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E\u003Ch3\u003EAbweichende E-Mail-Adressen\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-3\"\u003E\u003Cbutton class=\"button button-primary\" type=\"button\" ng-click=\"AllgemeinCtrl.exportUsersWithWrongEmailDomain()\"\u003EExport CSV\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Ctable\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Ctd\u003EID\u003C\u002Ftd\u003E\u003Ctd\u003EVorname, Name\u003C\u002Ftd\u003E\u003Ctd\u003EPersonalnummer\u003C\u002Ftd\u003E\u003Ctd\u003EE-Mail\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E\u003Ctr ng-repeat=\"employee in AllgemeinCtrl.employeesWithInvalidEmails track by $index\"\u003E\u003Ctd\u003E{{ employee.valuenet_id }}\u003C\u002Ftd\u003E\u003Ctd\u003E{{ employee.vorname + '&nbsp;' + employee.name }}\u003C\u002Ftd\u003E\u003Ctd\u003E{{ employee.personalnummer }}\u003C\u002Ftd\u003E\u003Ctd\u003E{{ employee.emails.toString() || '&nbsp;'}}\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca ng-click=\"AllgemeinCtrl.arbeitnehmerAnlegen(employee)\"\u003EBearbeiten\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C!--.row--\u003E\u003C!--  .columns.small-1.medium-1 ID--\u003E\u003C!--  .columns.small-4.medium-3 Vorname, Name--\u003E\u003C!--  .columns.small-2.medium-2 Personalnummer--\u003E\u003C!--  .columns.small-8.medium-4 E-Mail--\u003E\u003C!--  .columns.small-2.medium-2--\u003E\u003C!--  span.columns.small-10.medium-11.separator--\u003E\u003C!--.row(ng-repeat='employee in AllgemeinCtrl.employeesWithInvalidEmails track by employee.valuenet_id')--\u003E\u003C!--  .columns.small-1.medium-1 {{ employee.valuenet_id }}--\u003E\u003C!--  .columns.small-4.medium-3 {{ employee.vorname + '&nbsp;' + employee.name }}--\u003E\u003C!--  .columns.small-2.medium-2 {{ employee.personalnummer }}--\u003E\u003C!--  .columns.small-8.medium-4 {{ employee.emails.toString() || '&nbsp;'}}--\u003E\u003C!--  .columns.small-2.medium-2: a(ng-click='AllgemeinCtrl.arbeitnehmerAnlegen(employee)') Bearbeiten--\u003E\u003C!--  span.columns.small-10.medium-11.separator--\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.customer_domains","ng-if": "AllgemeinCtrl.iAmSpecialAdvisor"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EPersonalnummer Syntax & Registrierung\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv\u003E\u003Clabel\u003E\u003Cspan class=\"info component-name\"\u003EHier angeben, ob die Felder Pflichtfelder in der Registrierung sind und wie diese bezeichnet sein sollen.\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.organization_structure.cost_center.label","title": "Bezeichnung Kostenstelle","required": pug.escape(true),"validationMessages": {"required":"Bitte hier Kostenstelle eintragen"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-3 text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "expensesEnable","key": "AllgemeinCtrl.configuration.organization_structure.cost_center.is_required","title": "ist Pflichtfeld?"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.organization_structure.organization.label","title": "Bezeichnung Organisationseinheit","required": pug.escape(true),"validationMessages": {"required":"Bitte hier Organisationseinheit eintragen"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "organizationEnable","key": "AllgemeinCtrl.configuration.organization_structure.organization.is_required","title": "ist Pflichtfeld?"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.organizationStructureForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv\u003E\u003Clabel\u003E\u003Cspan class=\"info component-name\"\u003EHier kann ein spezieller Aufbau einer Personalnummer angegeben werden.\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.personal_number_config.syntax","id": "syntax","title": "Syntax in RegExp","type": "text","validationMessages": {"pattern":"Falsches Format","required":"Bitte Syntax angeben"},"attributes": {"ng-change":"AllgemeinCtrl.validateRegexFormat()","ng-disabled":"!AllgemeinCtrl.configuration.personal_number_config.is_enabled","ng-required":"AllgemeinCtrl.configuration.personal_number_config.is_enabled"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "personalNumberConfigIsEnabledID","key": "AllgemeinCtrl.configuration.personal_number_config.is_enabled","title": "Besonderer Syntax"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.personal_number_config.description","title": "Beschreibung","type": "text"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.personalNumberConfig"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"small-9 columns component-col\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "AllgemeinCtrl.configuration.personal_number_whitelist_error_message","id": "personal_number_whitelist_error_message_input","title": "Whitelist Funktionalität","type": "text","validationMessages": {"required":"Pflichtfeld"},"attributes": {"ng-init":"AllgemeinCtrl.configuration.personal_number_whitelist_error_message='Sie sind aktuell nicht berechtigt, fortzufahren. Bitte kontaktieren Sie zur Klärung Ihre Personalabteilung, vielen Dank.'","ng-disabled":"!AllgemeinCtrl.configuration.personal_number_whitelist","ng-required":"AllgemeinCtrl.configuration.personal_number_whitelist"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"small-3 columns text-right\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "personalNumberWhitelistConfigIsEnabledID","key": "AllgemeinCtrl.configuration.personal_number_whitelist","title": "Whitelist"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "AllgemeinCtrl.forms.whiteListConfigForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv ng-if=\"AllgemeinCtrl.employeesWithWrongPN.length &gt; 0 &amp;&amp; AllgemeinCtrl.configuration.personal_number_config.is_enabled === true\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E\u003Ch3\u003EAbweichende Personalnummern\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-3\"\u003E\u003Cbutton class=\"button button-primary\" type=\"button\" ng-click=\"AllgemeinCtrl.exportUsersWithWrongPattern()\"\u003EExport CSV\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 medium-2\"\u003EValueNetID\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8 medium-4\"\u003EPersonalnummer\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 medium-3\"\u003EVorname, Name\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8 medium-3\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"columns small-10 medium-11 separator\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"employee in AllgemeinCtrl.employeesWithWrongPN track by $index\"\u003E\u003Cdiv class=\"columns small-4 medium-2\"\u003E{{ employee.valuenet_id }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8 medium-4\"\u003E{{ employee.personalnummer }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 medium-3\"\u003E{{ employee.vorname + '&nbsp;' + employee.name }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8 medium-3\"\u003E\u003Ca ng-click=\"AllgemeinCtrl.arbeitnehmerAnlegen(employee)\"\u003EBearbeiten\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"columns small-10 medium-11 separator\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003ECMS-Inhalte anpassen\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\" ng-if=\"AllgemeinCtrl.iAmCmsEditor &amp;&amp; AllgemeinCtrl.configuration.modules.cms.enabled\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E\u003Ca ui-sref=\"inApp.cms.editorlist({ custId: AllgemeinCtrl.customerId })\"\u003EZum CMS\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"AllgemeinCtrl.iAmSpecialAdvisor || AllgemeinCtrl.iAmGAdvisor\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EBerater festlegen\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-9\"\u003E\u003Ch3\u003EBestehende Berater\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-3\"\u003E\u003Ca ng-click=\"AllgemeinCtrl.addAdvisor()\"\u003Ehinzufügen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cdiv class=\"row\" ng-repeat=\"advisor in AllgemeinCtrl.advisors track by advisor.id\"\u003E\u003Cdiv class=\"columns small-4 medium-2\"\u003E{{ advisor.id }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8 medium-4\"\u003E{{ AllgemeinCtrl.employeeService.employees[advisor.id].data.firstname + '&nbsp;' + AllgemeinCtrl.employeeService.employees[advisor.id].data.lastname }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 medium-3\"\u003E\u003Ca ng-if=\"!advisor.default\" ng-click=\"AllgemeinCtrl.setDefault(advisor.id)\"\u003EDefault setzen\u003C\u002Fa\u003E\u003Cspan ng-if=\"advisor.default\"\u003EDefault\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-8 medium-3\"\u003E\u003Ca ng-click=\"AllgemeinCtrl.removeAdvisor(advisor.id)\"\u003EEntfernen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"columns small-10 medium-11 separator\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;